import serialize from 'form-serialize';

import $ from '../core/Dom';
import Dispatch from '../core/Dispatch';
import request from '../core/request';

import { PRODUCT_LISTINGS_UPDATED } from './events';

const $body = $('body');

const track = $wrapper => {
    if (window.dataLayer === undefined) {
        window.dataLayer = [];
    }
    
    const $target = $wrapper || $body;

    $target.find('[data-products-listing]').each((listEl, listI) => {
        const $list = $(listEl);
        const $products = $list.find('[data-product]');
        const listData = $list.data('products-listing');
        const id = listData.id || 'unknown';
        const name = listData.name || 'unknown';
        const isSearchResult = listData.isSearchResult || false;
        const searchTerm = listData.searchTerm || '';
        const items = [];

        //console.log($id, $name, $products);

        $products.each((el, i) => {
            const $product = $(el);
            const productData = $product.data('product');
            const productTrackingData = productData.productTrackingData || null;
            
            //console.log(productTrackingData);

            if (productTrackingData !== null) {
                productTrackingData.index = i;
                
                if (isSearchResult) {
                    productTrackingData.item_category = 'Search Result';
                    productTrackingData.item_category2 = '';
                }
                
                items.push(productTrackingData);
            }
        });

        const ecommerceData = {
            currency: 'NOK',
            item_list_id: id,
            item_list_name: name,
            items
        };
        
        if (isSearchResult) {
            ecommerceData.search_term = searchTerm;
        }

        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: 'view_item_list',
            ecommerce: ecommerceData
        });
    });
};

const init = () => {
    track();
    Dispatch.on(PRODUCT_LISTINGS_UPDATED, (key, data) => track(data.wrapper));
};

const destroy = () => {

};

// Public api for module
export default {
    init,
    destroy
};
